import request from '@/utils/request'

export function getSourceList(data) {
  return request.post('/source/list', data)
}



// WEBPACK FOOTER //
// ./src/api/source.js